"use strict";

(function (global) {

  /**
  * Объект цикличный-итератор по направлениям вращения по сторонам света
  * @object Directions
  * @since 5.1.0.1523
  */
  var Directions = {
    index: 0,
    directions: ['N', 'E', 'S', 'W'],
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    next: function () {
      this.index++;
      this._reset();
      return this.directions[this.index];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    prev: function () {
      this.index--;
      this._reset();
      return this.directions[this.index];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    _reset: function () {
      if (this.index > this.directions.length - 1) this.index = 0;
      if (this.index < 0) this.index = this.directions.length - 1;
    }
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//



  /**
  * Управление бесконечной прокруткой
  * @namespace Core.preview.scrolling
  * @since 5.1.0.1523
  */
  global.scrolling = {
    _jFrame: null,
    _jArea: null,
    _jDoc: null,
    _href: null,
    _data: null,
    _jImage: null,
    _direction: null,
    _areaHeight: null,
    _pagesIterator: 2,
    _height: null,
    _width: null,
    _isIE: null,
    _jPageNumber: null,
    _lastPageHandlerTimout: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация бесконечной прокрутки документов в предросмотре
    * @function Core.preview.scrolling.init
    * @since 5.1.0.1523
    * @return {Core.preview.scrolling}
    */
    init: function (data) {
      var me = this;
      me._data = data || Core.preview.info;
      if (!me._data) return;

      if (!global.isScrollableDocument(me._data.convertedObj)) return;

      me._pagesIterator = 2;
      log.info('PREVIEW', 'Initializing endless document scrolling');
    
      this._initAttributes();
      me.postInit();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация полей
    * @function Core.preview.scrolling._initAttributes
    * @since 5.6.0
    * @private    
    */
    _initAttributes() {
      this._isIE = WA.ENV.browser.name === 'IE';
      this._jFrame = $("#contentContainer");
      this._jArea = this._jFrame.parent('div');
      this._areaHeight = this._jArea.height();
      this._areaWidth = this._jArea.width();
      this._jDoc = this._jFrame.contents();
      this._jPageNumber = $(".page-number-field");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Подгрузка стилей и изменение страницы для адаптации под прокрутку.
    * @function Core.preview.scrolling.init
    * @since 5.1.0.1523
    * @return {Core.preview.scrolling}
    */
    postInit: function () {
      log.info('PREVIEW', 'Preview frame loaded successfully');
      var me = this;

      me._href = format("{0}/{1}/{2}", me._data.previewHandlerUrl, me._data.convertedObj.id, '{0}');

      me.prepareFirstImage().done(function (scrolling) {
        scrolling
          .fillWithPlaceHolders()
          .attachToFrameScrolling()
          .loadNeighbors(1);
      });

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Первая картинка грузится всегда, она опорная точка, с нее
    * снимаются все параметры. Её-же мы делаем похожей на все остальные.
    * ИЕ8 слишком быстро выполняет js =), для него дополнительно используем
    * отложенный перерасчет величин.
    * @function Core.preview.scrolling.prepareFirstImage
    * @return {Deferred}
    * @since 5.1.0.1523
    */
    prepareFirstImage: function () {
      var d = $.Deferred();


      var me = this;
      me._jImage = me._jDoc.find('img:first').attr('id', 'page_1').data('pagenumber', '1').wrap('<div class="placeholder current primari">');
      log.info('PREVIEW', 'Preparing first image');

      me._width = me._jImage.width();
      me._height = me._jImage.height();

      me._jImage.parent('.placeholder').width(me._width).height(me._height);

      if (me._isIE) {
        setTimeout(function () {
          me._width = me._jImage.width();
          me._height = me._jImage.height();
          d.resolve(me);
        }, 100);
      } else {
        d.resolve(me);
      }

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * После загрузки фрейма наполняем его пустышками чтобы появилась
    * прокрутка необходимой высоты.
    * @function Core.preview.scrolling.fillWithPlaceHolders
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    fillWithPlaceHolders() {

      let page = {
        id: this._pagesIterator,
        width: this._width,
        height: this._height,
        src: '',
      };

      // Рендер будет выполняться один раз, установка номера страницу будет выполняться через jQuery 
      WA.templates.render('components/previewPage.compile.html', page).done((html) => {
        while (this._pagesIterator <= this._data.convertedObj.pageCount) {
          const jHtml = $(html);
          const jPlaceHolder = jHtml[2];
          const jImg = jPlaceHolder.children[0];
          const pageNumber = this._pagesIterator;
          jPlaceHolder.setAttribute('id', `placeholder_${pageNumber}`);
          jPlaceHolder.setAttribute('data-pagenumber', pageNumber);
          jImg.setAttribute('id', `page_${pageNumber}`);
          jImg.setAttribute('data-pagenumber', pageNumber);
          this._jDoc.find('body').append(jHtml);
          this._pagesIterator++;
        }
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * При перематывании страниц находим текущую страницу
    * @function Core.preview.scrolling.attachToFrameScrolling
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    attachToFrameScrolling: function () {
      var me = this;
      var frame = $(me._jFrame.get(0).contentWindow);

      frame.on('scroll touchmove', function () {
        // setTimeout потому-что в ie8 иначе не работает,
        // и чтобы слишком часто не вызывались вычисления.
        clearTimeout(me._lastPageHandlerTimout);
        me._lastPageHandlerTimout = setTimeout(function () {
          me.handleCurrentPage();
        }, 100);
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Поиск и выделение текущей страницы
    * @function Core.preview.scrolling.handleCurrentPage
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    handleCurrentPage: function () {
      var me = this;
      var jPage = $(me._jFrame.get(0).contentWindow.document.elementFromPoint(me._areaWidth * 0.5, (1 / 3) * me._areaHeight));

      me._jDoc.find('.placeholder').removeClass('current');
      jPage.parent('.placeholder').addClass('current');
      var id = jPage.data('pagenumber');

      if (id && !isNaN(id)) {
        me._jPageNumber.val(id);
        me.loadPage(id);
        me.loadNeighbors(id);
      };

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Загрузка страницы и обработка загрузки
    * @function Core.preview.scrolling.loadPage
    * @param {integer} pageNum номер страницы
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    loadPage: function (pageNum) {

      var me = this;
      var jPage = me._jDoc.find("#page_" + pageNum);

      var bindOnLoad = function () {
        jPage.parent().addClass('placeholder_spinner');
        jPage.attr('src', me.getURLForPage(pageNum)).one("load", function () {
          $(this).removeClass('invisible');
          $(this).parent().removeClass('placeholder_spinner');
        }).each(function () {
          //Если картинка была уже загружена, она помещеатся в браузерный кэш,
          // и при следующем откртытии страницы событие load не вызывается.
          // Вызываем его принудительно здесь.
          if (this.complete) $(this).load();
        });
      }

      if (!jPage.attr('src')) {
        if (WA.ENV.device.model && WA.ENV.device.model.toLowerCase() === 'ipad') {
          setTimeout(function () {
            bindOnLoad();
          });
        } else {
          bindOnLoad();
        }
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Вращение всех страниц в указанном направлении
    * @function Core.preview.scrolling.rotatePages
    * @param {String} direction 'N' - север, 'E' - восток, 'S' - юг 'W' - запад
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    rotatePages: function (direction) {
      var me = this;

      me._direction = direction;
      var jPage = me._jDoc.find("img");


      if (jPage.parent().hasClass('placeholder')) {
        var placeholders = me._jDoc.find(".placeholder");
        placeholders
          .removeClass('N E W S')
          .addClass(direction);
        switch (direction) {
          case 'N':
          case 'S':
            placeholders.css({ 'margin': '20px auto' });
            break;
          case 'E':
          case 'W':
            let sizeDiff = me._width - me._height;
            let placeholderMargin = {
              top: sizeDiff / 2 + 20 + 'px',
              bottom: sizeDiff + 20 + 'px',
            };
            placeholders.css({ 'margin': placeholderMargin.top + ' auto ' + placeholderMargin.bottom });
            break;
        }
      } else {
        jPage
          .removeClass('N E W S')
          .addClass(direction);
        if ($('.fit-to-height').hasClass('selected')) {
          $('.fit-to-height').click().click();
        }
      }
      setTimeout(function () { me.handleCurrentPage(); }, 0);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Вращение всех страниц по часовой стрелке
    * @function Core.preview.scrolling.rotateCW
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    rotateCW: function () {
      this.rotatePages(Directions.next());
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Вращение всех страниц против часовой стрелки
    * @function Core.preview.scrolling.rotateCCW
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    rotateCCW: function () {
      this.rotatePages(Directions.prev());
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * У страницы при малом масштабе могут быть видимые соседи. Их тоже требуется
    * загрузить чтобы картина была полной.
    * @function Core.preview.scrolling.loadNeighbors
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    loadNeighbors: function (pageNum, opt_rotate, opt_direction) {
      var me = this;

      pageNum = +pageNum; //преобразование в число, чтобы 1+2 не стало 12
      if (me._jImage.height()) {
        var neighborsCount = Math.ceil(me._areaHeight / me._jImage.height() / 2);
        for (var i = pageNum; i <= pageNum + neighborsCount; i++) {
          if (opt_rotate) me.rotatePage(i, opt_direction)
          else me.loadPage(i);
        }
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение url изображения по номеру страницы
    * @function Core.preview.scrolling.getURLForPage
    * @param {integer} pageNum номер страницы
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    getURLForPage: function (pageNum) {
      return format(this._href, pageNum);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Переход к указанной странице
    * @function Core.preview.scrolling.jumpToPage
    * @param {integer} pageNum номер страницы
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    jumpToPage: function (pageNum) {
      log.info('PREVIEW', 'Jumping to page #' + pageNum);

      var me = this;
      pageNum = +pageNum;

      if (pageNum > me._data.convertedObj.pageCount) pageNum = me._data.convertedObj.pageCount;

      if (WA.ENV.device.model && WA.ENV.device.model.toLowerCase() === 'ipad') {
        var jFrame = $(me._jFrame.get(0).contentWindow)
        var top = -(me._jDoc.find("#page_" + pageNum).offset().top - frames[0].window.prevScroll.y);
        frames[0].window.prevScroll.scrollTo(0, top);
        jFrame.trigger('scroll');
      } else {
        me._jDoc.scrollTop(me._jDoc.find("#page_" + pageNum).offset().top);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Смена масштаба
    * @function Core.preview.scrolling.setScale
    * @param {string} key масштаб
    * @return {Core.preview.scrolling}
    * @since 5.1.0.1523
    */
    setScale(key) {
      log.info('PREVIEW', 'Setting scale ' + key)

      //Это надо оставить, этот метод вызывается из обычного предпросмотра
      // и может вызваться раньше чем был init;
      this._initAttributes();
      this._jImage = this._jDoc.find('img:first');      
      const initHeight = +this._jImage.attr('initHeight');
      const initWidth = +this._jImage.attr('initWidth');

      const jHolders = this._jDoc.find('div.placeholder');
      if (jHolders.length) {
        let scale;
        let initSize = (this._direction === 'W' || this._direction === 'E') ? initHeight : initWidth;
        switch (key) {
          case 'w':
            // Здесь 40 = 20 + 10 + 10 (скролл + паддинги), делаем поправку, чтобы картинка корректно растягивалась по ширине            
              scale = (this._areaWidth - 40) / initSize;            
            break
          case 'h':
            scale = this._areaHeight / initHeight;
            break;
          case 'a':
            scale = Math.min(this._areaWidth / initWidth, this._areaHeight / initHeight);
            break
          default:
            scale = (+key) / 100;
        }

        // Рассчитать отступ слева и справа для html, чтобы при изменении масштаба не появлялся горизонтальный скрол                        
        let scaledWidth = initSize * scale;
        let sizeDiff = scaledWidth > this._areaWidth ? scaledWidth : (this._areaWidth - 42);
        sizeDiff -= initSize;
        let cssMargin = {
          left: sizeDiff / 2 + 'px',
          right: this._areaWidth - 30 - sizeDiff / 2 - initSize + 'px',
          top: 0
        };

        let html = this._jDoc.find('html');
        let cssTransformOrigin = 'center top';

        // FIXы для ie, т.к. в нем при изменении масштаба размер контейнера не изменятеся
        if (this._isIE) {
          let pageCount = this._data.convertedObj.pageCount;
          // Если масштаб меньше 1, то устанавливаем точку вращения по вертикали на нижней границе элемента и добавляем отрицательный отступ сверху
          if (scale < 1 && pageCount) {
            cssTransformOrigin = 'center bottom';
            // Верхний и нижний отступы
            let holderBottomMargin = 20;
            let holderTopMargin = 20;
            const holderBorder = 2;
            if (this._direction === 'W' || this._direction === 'E') {
              // Расчитаем верхний и нижний отступы по аналогии с расчетом при повороте, чтобы расчитать текущий размер контента                           
              let sizeDiff = this._width - this._height;
              holderBottomMargin += sizeDiff;
              holderTopMargin += sizeDiff / 2;
            }
            cssMargin.top = (pageCount * (holderBottomMargin + initHeight + holderBorder) + holderTopMargin) * (scale - 1) + 'px';
          }

          // Если размер документа меньше размера окна, то скрываем скрол, т.к. справа появляются лишние отступы          
          let cssOverflowX = (scaledWidth < this._areaWidth) ? 'hidden' : 'auto';
          html.css({ 'overflow-x': cssOverflowX });
        }
        // Изменить масштаб и указать отступы слева и справа, чтобы при изменении масштаба не появлялся горизонтальный скрол
        html.css({
          transform: `scale(${scale})`,
          'transform-origin': cssTransformOrigin,
          margin: `${cssMargin.top} ${cssMargin.right} auto ${cssMargin.left}`,
        });
      }
      setTimeout(() => {
        this.handleCurrentPage();
      }, 0);
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    
  }
})(window.Core.preview);


